import anime from "animejs";

export default class HeroSub {
  constructor() {
    this._hero = document.querySelector(".jsHero");
    this._heroBcg = document.querySelector(".jsHeroBcg");
    this._heroPagination = document.querySelectorAll(".jsHeroPagination");

    // helpers
    this._autoplay = {};
    this._autoplayTimeout = {};

    this._loaded = false;
    this._duration = 450;
    this._autoplayDuration = 7500;
    this._activeItem = 0;

    this.sampler = document.createElement("img");

    if (this._hero) this.init();
  }

  preloadImage(url) {
    this.animateImageOut();
    this.sampler.setAttribute("src", url);

    // animate in when img is fully loaded
    this.sampler.addEventListener("load", () => {
      if (this._loaded) {
        this.animateImageIn(url);
      } else {
        setTimeout(() => {
          this.animateImageIn(url);
        }, 245);
      }
    });
  }

  animateImageOut() {
    this._loaded = false;
    let imageOut = anime({
      targets: this._heroBcg,
      opacity: 0,
      duration: this._duration - 100,
      easing: "linear",
      scale: [1, 1.05]
    });

    setTimeout(() => {
      this._loaded = true;
    }, 750);
  }

  animateImageIn(url) {
    this._heroBcg.style.backgroundImage = `url(${url})`;

    let imageIn = anime({
      targets: this._heroBcg,
      opacity: 1,
      duration: this._duration,
      easing: "linear",
      scale: [1.05, 1]
    });
  }

  animatePaginationOut(item) {
    item.style.height = 0;
    item.querySelector(".jsPaginationTxt").style.translateX = `25px`;
    item.querySelector(".jsPaginationTxt").style.opacity = `0`;
  }

  animatePaginationIn(item, h) {
    item.style.height = `${h}px`;
    item.querySelector(".jsPaginationTxt").style.translateX = `0`;
    item.querySelector(".jsPaginationTxt").style.opacity = `1`;
  }

  setActiveItem(item) {
    this._activeItem = parseInt(item);

    for (let i = 0; i < this._heroPagination.length; i++) {
      let curr = this._heroPagination[i];

      if (curr.dataset.item == item) {
        curr.classList.add("active");
        this.animatePaginationIn(
          curr.querySelector(".jsPaginationContent"),
          curr.querySelector(".jsPaginationTxt").offsetHeight
        );
        this.preloadImage(curr.dataset.src);
      } else {
        if (curr.classList.contains("active")) {
          this.animatePaginationOut(curr.querySelector(".jsPaginationContent"));
        }
        curr.classList.remove("active");
      }
    }
  }

  setAutoplay(cleared) {
    if (cleared) {
      this._autoplayTimeout = setTimeout(() => {
        this._autoplay = setInterval(() => {
          this._activeItem++;

          if (this._activeItem >= this._heroPagination.length) {
            this._activeItem = 0;
          }

          this.setActiveItem(this._activeItem);
        }, this._autoplayDuration);
      }, this._duration);
    } else {
      this.setActiveItem(this._heroPagination[0].dataset.item);

      this._autoplay = setInterval(() => {
        this.setActiveItem(this._activeItem);
        this._activeItem++;

        if (this._activeItem >= this._heroPagination.length) {
          this._activeItem = 0;
        }
      }, this._autoplayDuration);
    }
  }

  init() {
    if (this._heroBcg != null)
    {
      let src = this._heroBcg.dataset.src;
    }

    if (this._heroPagination.length > 1) {
      this.setAutoplay(false);
    }

    for (let i = 0; i < this._heroPagination.length; i++) {
      this._heroPagination[i].addEventListener("click", () => {
        clearInterval(this._autoplay);
        clearTimeout(this._autoplayTimeout);

        this.setAutoplay(true);

        this.setActiveItem(this._heroPagination[i].dataset.item);
      });
    }
  }
}
